import request from '@/utils/request'


// 查询发现-文章商品列表
export function listDiscoverPostGoods(query) {
  return request({
    url: '/discovery/discover/post/goods/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询发现-文章商品分页
export function pageDiscoverPostGoods(query) {
  return request({
    url: '/discovery/discover/post/goods/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询发现-文章商品详细
export function getDiscoverPostGoods(data) {
  return request({
    url: '/discovery/discover/post/goods/detail',
    method: 'get',
    params: data
  })
}

// 新增发现-文章商品
export function addDiscoverPostGoods(data) {
  return request({
    url: '/discovery/discover/post/goods/add',
    method: 'post',
    data: data
  })
}

// 修改发现-文章商品
export function updateDiscoverPostGoods(data) {
  return request({
    url: '/discovery/discover/post/goods/edit',
    method: 'post',
    data: data
  })
}

// 删除发现-文章商品
export function delDiscoverPostGoods(data) {
  return request({
    url: '/discovery/discover/post/goods/delete',
    method: 'post',
    data: data
  })
}
